
import { required, email } from 'vuelidate/lib/validators'

export default function () {
  if (this.living.access) {
    return {
      living: {
        tower_id: {
          required
        },
        unit_id: {
          required
        },
        people_name: {
          required
        },
        people_email: {
          required,
          email
        },
        phone: {
          required
        }
      }
    }
  }

  if (!this.living.access) {
    return {
      living: {
        tower_id: {
          required
        },
        unit_id: {
          required
        },
        people_name: {
          required
        },
        phone: {
          required
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/livings/form/resources/validations.js